// client/src/config.js
// Centralized configuration for API and image URLs

// Get API URL from environment variable or use localhost as fallback
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// API endpoint for all API calls (includes /api path)
export const API_URL = `${API_BASE_URL}/api`;

/**
 * Get a placeholder image as SVG data URI (no external dependencies)
 * @param {string} text - Optional text to display (default: "No Image")
 * @returns {string} SVG data URI for placeholder
 */
export const getPlaceholderImage = (text = 'No Image') => {
  return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23e9ecef"/%3E%3Ctext x="50%25" y="50%25" font-family="Arial" font-size="14" fill="%23999" text-anchor="middle" dominant-baseline="middle"%3E${encodeURIComponent(text)}%3C/text%3E%3C/svg%3E`;
};

/**
 * Helper function to get full image URL
 * @param {string} imagePath - The image path from the database (e.g., "/uploads/products/image.jpg")
 * @returns {string} Full URL to the image
 */
export const getImageUrl = (imagePath) => {
  // Return placeholder if no image path
  if (!imagePath) return getPlaceholderImage();

  // If already a full URL (starts with http), return as is
  if (imagePath.startsWith('http')) return imagePath;

  // Otherwise, prepend the API base URL
  return `${API_BASE_URL}${imagePath}`;
};

/**
 * Helper function to get API endpoint URL
 * @param {string} endpoint - The API endpoint (e.g., "/products" or "products")
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};

// Export for debugging purposes
if (process.env.NODE_ENV === 'development') {
  console.log('🌐 API Configuration:');
  console.log('   API_BASE_URL:', API_BASE_URL);
  console.log('   API_URL:', API_URL);
}